export default "__VITE_ASSET__Bf2ldv3C__"